import {ReachTemplateContentChannel, ReachTemplateStatus, ReachTemplateType} from "../../apis/requests/templates/types";

export type ChipVariant =
  | "primary"
  | "secondary"
  | "inherit"
  | "success"
  | "warning"
  | "error"
  | "info"
  | "yellow"
  | "blue"
  | "pink"
  | "neon";

export const CHANNEL_DISPLAY: Record<ReachTemplateContentChannel, {label: string; variant: ChipVariant}> = {
  email: {label: "Email", variant: "info"},
  sms: {label: "SMS", variant: "success"},
  sms_with_landing_page: {label: "SMS + LP", variant: "success"},
  mms: {label: "MMS", variant: "blue"},
  mms_with_landing_page: {label: "MMS + LP", variant: "blue"},
  whatsapp: {label: "WhatsApp", variant: "success"},
};

export const STATUS_DISPLAY: Record<ReachTemplateStatus, {label: string; variant: ChipVariant}> = {
  active: {label: "Active", variant: "success"},
  draft: {label: "Draft", variant: "inherit"},
  inactive: {label: "Inactive", variant: "warning"},
};

export const TYPE_DISPLAY: Record<ReachTemplateType, {label: string; variant: ChipVariant}> = {
  marketing: {label: "Marketing", variant: "pink"},
  transactional: {label: "Transactional", variant: "yellow"},
  validation: {label: "Validation", variant: "blue"},
};
